import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import qs from 'query-string';

import Api from '../utils/Api';

// GetToken Component
class GetToken extends Component {
    constructor() {
        super();
        this.state = {
            success : false
        };
    }

    componentDidMount() {
        const code = qs.parse(this.props.location.search).code;
        if (code) {
            Api.getToken(code).then((res) => {
                if (res.token) {
                    localStorage.setItem('token', res.token);
                    this.setState({ success : true });
                }
            });
        }
    }

    render() {
        
        const spinnerWrapper = {
            display: "block",
            textAlign: "center",
            margin: "50px"
        };

        if (this.state.success) {
            return <Redirect to="/app" />;
        }

        return(
            <div>
                <div style={spinnerWrapper}>
                    <i className="fa fa-4x fa-sync fa-spin"></i>
                </div>
            </div>
        );
    }
}
export default GetToken;



// WEBPACK FOOTER //
// ./src/containers/GetToken.js